export default "__VITE_ASSET__0b715f59__"